import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IBoosterBenchmark} from "../../../../../../store/reducers/booster.reducer";
import {BenchmarkMetrics} from "../benchmark-metrics";
import {UserSubscription} from "../../../../../../user/user-subscription";

@Component({
    selector: 'db-benchmark-table',
    templateUrl: './benchmark-table.component.html',
    styleUrls: ['./benchmark-table.component.scss'],
    standalone: false
})
export class BenchmarkTableComponent {

  @Input() companyName: string;
  @Input() websiteId: number;
  @Input() benchmark: IBoosterBenchmark;
  @Input() isHosted: boolean;
  @Input() loading: boolean;
  @Input() userSubscription: UserSubscription;
  @Input() hostedCounts: any;
  @Input() demoUser: boolean;

  public readonly benchmarkMetrics = BenchmarkMetrics;

  @Output() onRerun: EventEmitter<void> = new EventEmitter<void>();
  @Output() onOptimize: EventEmitter<void> = new EventEmitter<void>();

}
